export enum RequestStatus {
  DRAFT = "Draft",
  SET_TO_REVIEW_1_2 = "SET to review 1/2",
  INCOMPLETE_INFORMATION = "Incomplete Information",
  SET_TO_REVIEW = "SET to review",
  REJECTED = "Rejected",
  APPROVED = "Approved",
  CLOSED = "Closed",
  AUTO_CLOSED = "Auto Closed",
  CANCELLED = "Cancelled"
}

export class RequestStatusClass {
  static list() {
    return [
      { "key": "DRAFT", "value": RequestStatus.DRAFT },
      { "key": "SET_TO_REVIEW_1_2", "value": RequestStatus.SET_TO_REVIEW_1_2 },
      { "key": "INCOMPLETE_INFORMATION", "value": RequestStatus.INCOMPLETE_INFORMATION },
      { "key": "SET_TO_REVIEW", "value": RequestStatus.SET_TO_REVIEW },
      { "key": "REJECTED", "value": RequestStatus.REJECTED },
      { "key": "APPROVED", "value": RequestStatus.APPROVED },
      { "key": "CLOSED", "value": RequestStatus.CLOSED },
      { "key": "AUTO_CLOSED", "value": RequestStatus.AUTO_CLOSED },
      { "key": "CANCELLED", "value": RequestStatus.CANCELLED }
    ]
  }
  static search() {
    return [
      { "key": "DRAFT", "value": RequestStatus.DRAFT },
      { "key": "INCOMPLETE_INFORMATION", "value": RequestStatus.INCOMPLETE_INFORMATION },
      { "key": "SET_TO_REVIEW", "value": RequestStatus.SET_TO_REVIEW },
      { "key": "REJECTED", "value": RequestStatus.REJECTED },
      { "key": "APPROVED", "value": RequestStatus.APPROVED },
      { "key": "CLOSED", "value": RequestStatus.CLOSED },
      { "key": "AUTO_CLOSED", "value": RequestStatus.AUTO_CLOSED },
      { "key": "CANCELLED", "value": RequestStatus.CANCELLED }
    ]
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/models/request-status.ts